import * as React from "react";
import {
  Box, Grid, Paper, TextField, InputAdornment, Chip,
  Stack, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Autocomplete,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  ToggleButtonGroup,
  ToggleButton,
  Checkbox
} from "@mui/material";
import {
  Search as SearchIcon,
  Home as HomeIcon,
  PointOfSale as PosIcon,
  ReceiptLong as ReceiptLongIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  ExpandMore,
  WarehouseOutlined,
  LocationOnOutlined,
  Edit,
  TableChart,
} from "@mui/icons-material";
import { addMinutes, addMonths, addDays, differenceInDays, parse, parseISO, startOfMonth, format, differenceInMonths, differenceInWeeks, isValid } from "date-fns";

import ReceiptPagoPanel from "./receiptpagopanel";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import { formatNumberWithCommas } from "../../../../utils/generalFunctions";
import { fetchCargosAsignados } from "../../../../utils/generalsFetch";
import InvoicePanel from "./invoicepanel";
import ProductCard from "./productcard";
import MetodoDePagoDialog from "../components/metododepagodialog";
import AlertMessageDialog from "../../../../components/Dialogs/alertMessageDialog";
import { impresionrecibopagocargosprestamo } from "../../prestamos/pagos/imprimirpagos";
import EditAmortizationDialog from "../../prestamos/options/editamortizationdialog";
import AbonoCapitalDialog from "../../prestamos/options/abonocapitaldialog";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import Can from "../../../../components/Can";
import { a } from "@react-spring/web";



const MOCK_LOANS = [
  { id: "p1", nombre: "juwuw", producto: "juwuw"},
  { id: "p2", nombre: "kdkd", producto:"kdkd"},
  { id: "p3", nombre: "Cambio de aceite", producto:"Cambio de aceite"},
];

const DEFAULT_CLIENT = { id: "walkin", name: "Consumidor final" };


export default function PagosPrestamoScreen(props) {
  const [search, setSearch] = React.useState("");
  const [catalog, setCatalog] = React.useState(MOCK_LOANS);
  const [cart, setCart] = React.useState([]);
  const [priceList, setPriceList] = React.useState("general");
  const [invoiceType, setInvoiceType] = React.useState("cf01");
  const [client, setClient] = React.useState(DEFAULT_CLIENT);
  const [showClientDialog, setShowClientDialog] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [currentShift, setCurrentShift] = React.useState(null);
  const [prestamos, setPrestamos] = React.useState([]);
  const [prestamo, setPrestamo] = React.useState(null);
  const [prestamoDetalle, setPrestamoDetalle] = React.useState(null);
  const [atraso, setAtraso] = React.useState(0);
  const [amortizaciones, setAmortizaciones] = React.useState([]);
  const [amortizacionesEdit, setAmortizacionesEdit] = React.useState([]);
  const [ultPago, setUltPago] = React.useState(null);
  const [showEditPagosDialog, setShowEditPagosDialog] = React.useState(false);
  const [showAbonoCapitalDialog, setShowAbonoCapitalDialog] = React.useState(false);
  const [selectedCuotas, setSelectedCuotas] = React.useState([]);
  const [checkedCuotas, setCheckedCuotas] = React.useState([]);
  const [inputValuePrestamo, setInputValuePrestamo] = React.useState('');
  const [pagoTipo, setPagoTipo] = React.useState("cuota");
  const [showPaymentMethodDialog, setShowPaymentMethodDialog] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [alertTitle, setAlertTitle] = React.useState("");
  const [alertSeverity, setAlertSeverity] = React.useState("success");
  const [gestionCargosPagados, setGestionCargosPagados] = React.useState([]);
  const [recuperaciones, setRecuperaciones] = React.useState([]);
  const [cargosAsignados, setCargosAsignados] = React.useState([]);

  const reloadCargosAsignados = React.useCallback(async (idPrestamo) => {
    if (!idPrestamo) { setCargosAsignados([]); return; }
    try {
      const data = await fetchCargosAsignados({
        idPrestamo,
        idcompany: localStorage.getItem('idcompany'),
        usuarioId: localStorage.getItem('id'),
      });
      // Solo cargos con saldo (pendiente o parcial), ya vienen ordenados FIFO desde backend
      setCargosAsignados(
        (data || []).filter((c) => c.estado === 'pendiente' || c.estado === 'parcial')
      );
    } catch (e) {
      console.error('Error fetching cargos asignados:', e);
      setCargosAsignados([]);
    }
  }, []);

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const normalized = typeof value === "string" ? value.replaceAll(",", "") : value;
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const normalizeAmortizacion = (amortizacion) => ({
    ...amortizacion,
    valor: toNumber(amortizacion?.valor ?? amortizacion?.cuota ?? amortizacion?.interes).toFixed(2),
    mora: toNumber(amortizacion?.mora).toFixed(2),
    descuento: toNumber(amortizacion?.descuento),
    aumento_interes: toNumber(amortizacion?.aumento_interes),
    interes_acumulado: toNumber(amortizacion?.interes_acumulado),
    interesPagado: toNumber(amortizacion?.interesPagado),
    capitalPagado: toNumber(amortizacion?.capitalPagado),
    capital: toNumber(amortizacion?.capital),
  });

  const formatDateUTC = (dateValue) => {
    if (!dateValue) return "";

    const rawValue = String(dateValue);
    const parsedRfc = parse(rawValue, "EEE, dd MMM yyyy HH:mm:ss 'GMT'", new Date());
    const parsedIso = parseISO(rawValue);
    const date = isValid(parsedRfc) ? parsedRfc : parsedIso;
    if (!isValid(date)) return "";

    // Keep original UTC calendar day while still using date-fns format.
    const shiftedToUtcCalendar = addMinutes(date, date.getTimezoneOffset());
    return format(shiftedToUtcCalendar, "dd-MM-yyyy");
  };

  const parseJsonObject = (value) => {
    if (!value) return {};
    if (typeof value === "object") return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return {};
    }
  };

  const interesProducto = parseJsonObject(prestamoDetalle?.interes_producto);
  const esInteresDiario = Boolean(interesProducto?.interesDiario);
  
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/activos/${localStorage.getItem('idcompany')}`,{
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
        'X-company-ID': localStorage.getItem('idcompany')
      }
    })
      .then(response => response.json())
      .then(data => setPrestamos(data))
      .catch(error => console.error('Error fetching prestamos:', error));

  
  }, []);


  const calcularAmortizacionIndefinido2 = (data) => {  
    var fechahoy = new Date();
    var fechainicio = new Date(data.prestamo.fecha_inicio);
    var fechaultimacuota = new Date(data.prestamo.fecha_ultima_cuota);
//    var meses = Math.floor((fechahoy - (data.prestamo.fecha_ultimo_pago_original?fechaultimopago:fechainicio)) / (1000 * 60 * 60 * 24 * 30));

    var dias = Math.floor((fechahoy - (data.prestamo.fecha_ultima_cuota?fechaultimacuota:fechainicio)) / (1000 * 60 * 60 * 24));
    var quincenas = Math.floor(dias / 15);
    var semanas = Math.floor(dias / 7);
    var meses = Math.floor(dias / 30);
    var tiempo = 0;

    if(data.prestamo.frecuencia == "Diario") {
      tiempo = dias;
    }else if(data.prestamo.frecuencia == "Semanal") {
      tiempo = semanas;
    }else if(data.prestamo.frecuencia == "Quincenal") {
      tiempo = quincenas;
    }
    else if(data.prestamo.frecuencia == "Mensual") {
      tiempo = meses;
    }
    

    var cuotas = []
    var cuotasFechas = []
    var ultPago = data.amortizaciones.length>0?data.amortizaciones[data.amortizaciones.length - 1]:null;
    setUltPago(ultPago);
    var nocuota = ultPago?ultPago.numero_cuota:0;
    var capital = ultPago?ultPago.capital:data.prestamo.monto_solicitado;


    

    data.amortizaciones_pendientes.forEach(amortizacion => {
      var fecha = new Date(amortizacion.fecha_cuota);

      const day = String(fecha.getUTCDate()).padStart(2, "0");
      const month = String(fecha.getUTCMonth() + 1).padStart(2, "0");
      const year = fecha.getUTCFullYear();

    
      cuotasFechas.push({fecha:`${day}-${month}-${year}`,nocuota:amortizacion.nocuota});
    });


    for(var i = 0; i < tiempo; i++) {
      var fecha = data.prestamo.fecha_ultima_cuota?fechaultimacuota:fechainicio;      

      if(data.prestamo.frecuencia == "Diario") { 
        fecha = addDays(fecha, (i+1));
        fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();        
      }else if(data.prestamo.frecuencia == "Semanal") {
        fecha = addDays(fecha, (i+1)*7); 
        fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
      }else if(data.prestamo.frecuencia == "Quincenal") {
        fecha = addDays(fecha, i*15); 
        fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
      }else if(data.prestamo.frecuencia == "Mensual") {
        fecha = addMonths(fecha, (i+1));        
        fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
      }
      var existe = cuotasFechas.find(cuota => cuota.fecha == fecha);

      if(!existe) {
        cuotasFechas.push({fecha:fecha,nocuota:null})
      }     
    }
    
    for(var i = 0; i < cuotasFechas.length; i++) {
      var fecha = cuotasFechas[i].fecha;

      if(cuotasFechas[i].nocuota == null) {
        nocuota++;
        // Get the month gap between now and the cuota's date
        // fecha is in format "dd/mm/yyyy"
        const cuotaDate =  parse(fecha, 'dd-MM-yyyy', new Date());
        const now = new Date();
        var dias = differenceInDays(now, cuotaDate);        
        var moraCalculada = 0;
        if(dias > 3) {
          moraCalculada = (capital * (data.prestamo.interes/100))*(3/100)
          setAtraso((atraso+(capital * (data.prestamo.interes/100))+moraCalculada).toFixed(2));
        }

        cuotas.push({
          nocuota: nocuota,
          Fecha:  fecha,
          capital: capital,
          interes: data.prestamo.interes,
          mora: formatNumberWithCommas(moraCalculada.toFixed(2)),
          valor:(capital * (data.prestamo.interes/100)).toFixed(2),
          descuento:0,
          pagadodescuento:0,
          status:'noexiste'
        });
      }else{
        setAtraso(data.atraso);
        var amortizacion = data.amortizaciones_pendientes.find(amortizacion => amortizacion.nocuota == cuotasFechas[i].nocuota);
        var nocuota = cuotasFechas[i].nocuota;
        cuotas.push({
          nocuota: nocuota,
          Fecha:  fecha,
          capital: amortizacion.capital,
          interes: amortizacion.interes,
          mora: amortizacion.mora,
          valor:amortizacion.valor,
          descuento:0,
          pagadodescuento:0,
          status:'existe'
        });
      }
    }
    setAmortizaciones(cuotas);


  }

  const calcularAmortizacionIndefinido = (data) => {  
    var fechahoy = new Date();
    var fechainicio = new Date(data.prestamo.fecha_inicio);
    var fechaultimacuota = new Date(data.prestamo.fecha_ultima_cuota);
//    var meses = Math.floor((fechahoy - (data.prestamo.fecha_ultimo_pago_original?fechaultimopago:fechainicio)) / (1000 * 60 * 60 * 24 * 30));

    var dias = Math.floor((fechahoy - (data.prestamo.fecha_ultima_cuota?fechaultimacuota:fechainicio)) / (1000 * 60 * 60 * 24));
    var quincenas = Math.floor(dias / 15);
    var semanas = Math.floor(dias / 7);
    var meses = Math.floor(dias / 30);
    var tiempo = 0;

    if(data.prestamo.frecuencia == "Diario") {
      tiempo = dias;
    }else if(data.prestamo.frecuencia == "Semanal") {
      tiempo = semanas;
    }else if(data.prestamo.frecuencia == "Quincenal") {
      tiempo = quincenas;
    }
    else if(data.prestamo.frecuencia == "Mensual") {
      tiempo = 1// meses+1;
    }
    

    var cuotas = []
    var cuotasFechas = []
    var ultPago = data.amortizaciones.length>0?data.amortizaciones[data.amortizaciones.length - 1]:null;
    setUltPago(ultPago);
    var nocuota = ultPago?ultPago.numero_cuota:0;
    var capital = ultPago?ultPago.capital:data.prestamo.monto_solicitado;

    

    if(JSON.parse(data.prestamo.interes_producto).interesDiario) {

      data.amortizaciones_pendientes.forEach(amortizacion => {
      var fecha = new Date(amortizacion.fecha_cuota);

      const day = String(fecha.getUTCDate()).padStart(2, "0");
      const month = String(fecha.getUTCMonth() + 1).padStart(2, "0");
      const year = fecha.getUTCFullYear();

    
      cuotasFechas.push({fecha:`${day}-${month}-${year}`,nocuota:amortizacion.nocuota});
      });


      for(var i = 0; i < tiempo; i++) {
        var fecha = data.prestamo.fecha_ultima_cuota?fechaultimacuota:fechainicio;      

        if(data.prestamo.frecuencia == "Diario") { 
          fecha = addDays(fecha, (i+1));
          fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();        
        }else if(data.prestamo.frecuencia == "Semanal") {
          fecha = addDays(fecha, (i+1)*7); 
          fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
        }else if(data.prestamo.frecuencia == "Quincenal") {
          fecha = addDays(fecha, i*15); 
          fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
        }else if(data.prestamo.frecuencia == "Mensual") {
          fecha = addMonths(fecha, (i+1));        
          fecha = fecha.getDate() + "-" + ((fecha.getMonth()+1) ) + "-" + fecha.getFullYear();
        }
        var existe = cuotasFechas.find(cuota => cuota.fecha == fecha);

//        if(!existe) {
  //        cuotasFechas.push({fecha:fecha,nocuota:null})
    //    }     
      }
      
      for(var i = 0; i < cuotasFechas.length; i++) {
        var fecha = cuotasFechas[i].fecha;

        if(cuotasFechas[i].nocuota == null) {
          nocuota++;
          // Get the month gap between now and the cuota's date
          // fecha is in format "dd/mm/yyyy"
          const cuotaDate =  parse(fecha, 'dd-MM-yyyy', new Date());
          const now = new Date();
          var dias = differenceInDays(now, cuotaDate);        
          var moraCalculada = 0;
          if(dias > 3) {
            moraCalculada = (capital * (data.prestamo.interes/100))*(3/100)
            setAtraso((atraso+(capital * (data.prestamo.interes/100))+moraCalculada).toFixed(2));
          }

          cuotas.push({
            nocuota: nocuota,
            Fecha:  fecha,
            capital: capital,
            interes: data.prestamo.interes,
            mora: formatNumberWithCommas(moraCalculada.toFixed(2)),
            valor:(capital * (data.prestamo.interes/100)).toFixed(2),
            cuotaoriginal:(capital * (data.prestamo.interes/100)).toFixed(2),
            descuento:0,
            pagadodescuento:0,
            status:'noexiste',
            interesPagado: 0,
            capitalPagado: 0,
            moraPagado: 0,

          });
        }else{
          setAtraso(data.atraso);
          var amortizacion = data.amortizaciones_pendientes.find(amortizacion => amortizacion.nocuota == cuotasFechas[i].nocuota);
          var nocuota = cuotasFechas[i].nocuota;



          cuotas.push({
            nocuota: nocuota,
            numero_cuota: nocuota,
            Fecha:  fecha,
            fecha_pagado: amortizacion.fecha_pagado,
            interes_acumulado: parseFloat(amortizacion.interes_acumulado),
            capital: data.prestamo.capitalPendiente,
            interes: amortizacion.interes,
            interesPagado: amortizacion.interesPagado,
            capitalPagado: amortizacion.capitalPagado,
            aumento_interes: amortizacion.aumento_interes,
            mora: amortizacion.mora,
            valor:amortizacion.valor,
            cuotaoriginal:amortizacion.cuota,
            descuento:amortizacion.descuento,
            pagadodescuento:0,
            status:'existe'
          });
        }
      }

    
      cuotas.map((cuota,index) => {
        const dateString = fechainicio;
        const date = new Date(dateString);

        // Get UTC components
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        const formatted = `${day}-${month}-${year}`;
        var previousAmortizacion = null;                         
        var daysBetween = 0;
        

        // El ancla de los días SIEMPRE es la fecha del último pago (fecha_pago_en_pago),
        // nunca la fecha de la fila de cuota: esa fecha no avanza con los pagos
        // (los pagos hacen UPDATE sobre la misma fila) y anclar ahí duplica los días
        // ya cobrados, inflando el `pendiente` que se persiste con cada pago.
        previousAmortizacion = data.prestamo.fecha_pago_en_pago?data.prestamo.fecha_pago_en_pago: formatted;
        var pendiente = data.prestamo.pendiente_en_pago?data.prestamo.pendiente_en_pago:0;

        daysBetween = (differenceInDays(new Date(),parse(previousAmortizacion, 'dd-MM-yyyy', new Date())));  
        var interes_nuevo = toNumber(cuota.capital) * ((toNumber(data.prestamo.interes) / 100) / 30) * daysBetween;
        var interes_total = interes_nuevo + toNumber(pendiente) - toNumber(cuota.descuento) + toNumber(cuota.aumento_interes);
        
        const divisor = toNumber(cuota.capital) * ((toNumber(data.prestamo.interes) / 100) / 30);
        cuota.dias_acumulados = divisor > 0 ? (interes_total / divisor).toFixed(2) : "0.00";
        cuota.valor = toNumber(interes_total).toFixed(2);

        cuota.valorPagado = toNumber(cuota.interesPagado) + toNumber(cuota.capitalPagado);
        


/*        if(index == cuotas.length - 1) {
          if(cuota.fecha_pagado){
            var cuotaDiaria = (cuota["interes"]/30);
            var diasPasados = Math.ceil(cuota["interesPagado"]/cuotaDiaria);
            
            //previousAmortizacion = addDays(parse(previousAmortizacion, 'dd-MM-yyyy', new Date()), diasPasados);
         //   const day = String(previousAmortizacion.getUTCDate()).padStart(2, '0');
            const month = String(previousAmortizacion.getUTCMonth() + 1).padStart(2, '0');
            const year = previousAmortizacion.getUTCFullYear();
            previousAmortizacion = `${day}-${month}-${year}`;
            var difference = differenceInDays(parse(previousAmortizacion, 'dd-MM-yyyy', new Date()),new Date());
            alert(difference);
    
          }
          daysBetween = (differenceInDays(parse(previousAmortizacion, 'dd-MM-yyyy', new Date()),new Date()));  
          

          var isLater = daysBetween > 0  || daysBetween < -30;
          
          var valorCuota = !isLater ? ((cuota.valor/30)*Math.abs(daysBetween)).toFixed(2) : cuota.valor
          
          cuota.cuotaoriginal = cuota.valor;
          cuota.valor = valorCuota;
    
        }
        else{

          if(cuota.fecha_pagado){
            var proximaCuota = cuotas[index+1];


            var cuotaDiaria = (cuota["interes"]/30);
            var diasPasados = Math.ceil(cuota["interesPagado"]/cuotaDiaria);
            
            var actualDate = addDays(parse(cuota.Fecha, 'dd-MM-yyyy', new Date()), diasPasados);
            actualDate = actualDate.getDate() + "-" + ((actualDate.getMonth()+1) ) + "-" + actualDate.getFullYear();
            var daysBetween = differenceInDays(parse(actualDate, 'dd-MM-yyyy', new Date()),parse(proximaCuota.Fecha, 'dd-MM-yyyy', new Date()));

            var valorCuota = ((cuota.valor/30)*Math.abs(daysBetween)).toFixed(2) 

            cuota.cuotaoriginal = cuota.valor;
            cuota.valor = valorCuota;
          }
  
        }
*/        
        
      });
    }
    else{

      var amortizaciones = data.amortizaciones.filter(amortizacion => amortizacion.capitalPagado == 0);
      var amortizacionesPendientes = data.amortizaciones_pendientes.filter(amortizacion => amortizacion.capitalPagado == 0);

      amortizacionesPendientes.forEach(amortizacion => {
        amortizacion.valor = amortizacion.valor-(parseFloat(amortizacion.interesPagado)+parseFloat(amortizacion.capitalPagado));
        amortizacion.Fecha = formatDateUTC(amortizacion.fecha_cuota, 'dd-MM-yyyy');
        cuotas.push(normalizeAmortizacion(amortizacion));
      });



      var prevFecha = amortizaciones[amortizaciones.length-1].fecha;
      var fechaBase = parse(prevFecha, 'dd-MM-yyyy', new Date());
      var ahora = new Date();
      var frecuencia = data.prestamo.frecuencia;

      var cantidad = 0;
      if (frecuencia === 'Diario')         cantidad = differenceInDays(ahora, fechaBase);
      else if (frecuencia === 'Semanal')   cantidad = differenceInWeeks(ahora, fechaBase);
      else if (frecuencia === 'Quincenal') cantidad = Math.floor(differenceInDays(ahora, fechaBase) / 15);
      else if (frecuencia === 'Mensual')   cantidad = differenceInMonths(ahora, fechaBase);

      for (var i = 0; i < cantidad; i++) {
        var fecha;
        if (frecuencia === 'Diario')         fecha = addDays(fechaBase, i + 1);
        else if (frecuencia === 'Semanal')   fecha = addDays(fechaBase, (i + 1) * 7);
        else if (frecuencia === 'Quincenal') fecha = addDays(fechaBase, (i + 1) * 15);
        else if (frecuencia === 'Mensual')   fecha = addMonths(fechaBase, i + 1);
        else continue;

        var ultimaAmort = amortizaciones[amortizaciones.length - 1];
        var moraCalculada = (ultimaAmort.interes_original*(data.prestamo.mora/100))/30*(differenceInDays(new Date(),addDays(fecha,3)))
        cuotas.push({
          nocuota: amortizaciones.length + i + 1,
          Fecha: format(fecha, 'dd-MM-yyyy'),
          valor: ultimaAmort.interes,
          estado: "pendiente",
          valorPagado: "0.00",
          capital: ultimaAmort.capital,
          interes: ultimaAmort.interes,
          mora: moraCalculada,
          descuento: ultimaAmort.descuento,
          pagadodescuento: ultimaAmort.pagadodescuento,
          capitalPagado: 0,
          interesPagado: 0,
          moraPagado: 0,
          status: ultimaAmort.status
        });
      }

    }
    setAmortizaciones(cuotas);



  }



  const handlePrestamoChange = async(event, value) => {
    setPrestamo(value);
    setPrestamoDetalle(null);
    setAtraso(0);
    setAmortizaciones([]);
    setSelectedCuotas([]);
    setCheckedCuotas([]);
    setPagoTipo("cuota");
    if (!value) return; // Don't fetch if no loan is selected
    
    const prestamoDetalle = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/detalles${value.metodo == 'plazo_indefinido' ? '/plazo_indefinido' : ''}/${value.prestamo_original_id}`,{
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
        'X-company-ID': localStorage.getItem('idcompany')
      }
    })
      .then(response => response.json())
      .then(data => {
        setPrestamoDetalle(data.prestamo);
        
        if(value.metodo == 'plazo_indefinido') {

          calcularAmortizacionIndefinido(data);
        }else{
          const amortizacionesNormalizadas = (data.amortizaciones_pendientes || []).map(normalizeAmortizacion);
          setAmortizaciones(amortizacionesNormalizadas);
          
          setAmortizacionesEdit(amortizacionesNormalizadas.map(amortizacion => ({
            ...amortizacion,
            numero_cuota: amortizacion.nocuota,
            fecha: amortizacion.Fecha,
            capital: amortizacion.scapital,
            interes: amortizacion.sinteres,
            mora: amortizacion.mora,
            cuota: amortizacion.valor,
            descuento: amortizacion.descuento,
            pagadodescuento: amortizacion.pagadodescuento,
            status: 'noexiste'
          })));
          setAtraso(data.atraso);
        }

        
        setGestionCargosPagados(data.gestion_cargos_pagados || []);
        setRecuperaciones(data.recuperaciones || []);
      })
      .catch(error => {
        // Clear data on error
        setPrestamo(null);
        setPrestamoDetalle(null);
        setAtraso(0);
        setAmortizaciones([]);
        setGestionCargosPagados([]);
      });

      const catalog = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/categorias_cargos/prestamos/${value.producto_financiero_id}?idcompany=${localStorage.getItem('idcompany')}`,{
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      })
      .then(response => response.json())
      .then(data => setCatalog(data))
      .catch(error => console.error('Error fetching catalog:', error));

      // Cargar cargos asignados con saldo pendiente para este prestamo
      await reloadCargosAsignados(value.prestamo_original_id);
  };

  const reiniciar = () => {
    setPrestamo(null);
    setInputValuePrestamo('');
    setPrestamoDetalle(null);
    setAtraso(0);
    setAmortizaciones([]);
    setSelectedCuotas([]);
    setCheckedCuotas([]);
  };

  // Selected cuotas management functions
  const mapAmortizacionToCuota = (amortizacion) => {
    return {
      nocuota: amortizacion.nocuota,
      fecha: amortizacion.Fecha,
      valor: amortizacion.valor,
      mora: amortizacion.mora,
      capital: amortizacion.capital,
      interes: amortizacion.interes,
      descuento: amortizacion.descuento || 0,
      pagadodescuento: amortizacion.pagadodescuento || 0,
      status: amortizacion.status || 'existe'
    };
  };

  const isCuotaSelected = (nocuota) => {
    return checkedCuotas.some(cuota => cuota.nocuota === nocuota);
  };

  const areAllCuotasSelected = () => {
    return amortizaciones.length > 0 && amortizaciones.every(amort => isCuotaSelected(amort.nocuota));
  };

  const areSomeCuotasSelected = () => {
    return amortizaciones.some(amort => isCuotaSelected(amort.nocuota));
  };

  const handleSelectAllCuotas = (checked) => {
    if (checked) {
      const allCuotas = amortizaciones.map(mapAmortizacionToCuota);
      setCheckedCuotas(allCuotas);
      
    } else {
      setCheckedCuotas([]);
    }
  };

  const handleSelectCuota = (amortizacion, checked) => {
    if (checked) {
      if (!isCuotaSelected(amortizacion.nocuota)) {
        setCheckedCuotas([...checkedCuotas, mapAmortizacionToCuota(amortizacion)]);
      }
    } else {
      setCheckedCuotas(checkedCuotas.filter(cuota => cuota.nocuota !== amortizacion.nocuota));
    }
   
  };

  const handleSaveAmortization = async (updatedAmortizacion) => {    

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/prestamos/${prestamo.prestamo_original_id}/amortizacion`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          amortizacion: updatedAmortizacion,
          metodo: prestamo.metodo
        })
      });

      if (!response.ok) {
        throw new Error('Error al actualizar la amortización');
      }

      // Update local state
      setAmortizaciones(updatedAmortizacion);
      
      // Refresh loan data
      handlePrestamoChange(null, prestamo);
    } catch (error) {
      console.error('Error updating amortization:', error);
      throw error;
    }

  };


  // Cart management functions
  const addToCart = (item) => {
    setCart((prev) => {
      const found = prev.find((r) => r.id === item.id);
      if (found) {
        return prev.map((r) =>
          r.id === item.id && r.qty < 1
            ? { ...r, qty: r.qty + 1, total: (r.qty + 1) * r.price }
            : r
        )
      }
      return [...prev, { 
        id: item.id, 
        name: item.nombre, 
        price: item.montoFijo, 
        qty: 1, 
        total: item.montoFijo 
      }];
    });
  };

  const increase = (id) => {
    setCart((prev) =>
      prev.map((r) =>
        r.id === id && r.qty < 1
          ? { ...r, qty: r.qty + 1, total: (r.qty + 1) * r.price }
          : r
      )
    );
  };

  const decrease = (id) => {
    setCart((prev) =>
      prev.map((r) => (r.id === id ? { ...r, qty: Math.max(0, r.qty - 1), total: Math.max(0, r.qty - 1) * r.price } : r))
    );
  };

  const removeItem = (id) => {
    setCart((prev) => prev.filter((r) => r.id !== id));
  };

  const totals = React.useMemo(() => {
    const subtotal = cart.reduce((s, r) => s + r.total, 0);
    const taxes = 0;
    return { subtotal, taxes, total: subtotal + taxes };
  }, [cart]);

  const handlePaymentMethod = () => {
    setShowPaymentMethodDialog(true);
  };

  const processPaymentCargos = async (paymentData) => {
    var cargos = [];
    cart.forEach(item => {
      cargos.push({
        id_cargo:item.id,
        concepto: item.name,
        monto: item.price,
        cliente: {"nombre": prestamo.cliente_nombre, "identificacion": prestamo.cliente_identificacion},
        id_producto: "",
        id_prestamo: prestamo.prestamo_original_id,
        descripcion: "Pago de cargo",
        id_sucursal: localStorage.getItem('id_sucursal'),
        created_by: localStorage.getItem('id'),
        idcompany: localStorage.getItem('idcompany'),
        metodo_pago: paymentData.payments.map(payment => ({
          method: payment.method,
          amount: payment.amount,
          reference: payment.reference
        }))
      });
    });

    try {
      let url = `${process.env.REACT_APP_SERVER_URL}/api/gestion_cargos/pagar`;
      const payload = {
        id_prestamo: prestamo.prestamo_original_id,
        id_sucursal: localStorage.getItem('id_sucursal'),
        created_by: localStorage.getItem('id'),
        idcompany: localStorage.getItem('idcompany'),
        cargos: cargos
      };



      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const error = await response.json();
        setAlertTitle("Error");
        setAlertMessage(error.message || "Error al procesar el pago del préstamo");
        setAlertSeverity("error");
        setAlertOpen(true);
        return;
      }

      const data = await response.json();
      setAlertTitle("Éxito");
      setAlertMessage("Pago de cargos procesado correctamente");
      setAlertSeverity("success");
      setAlertOpen(true);
      impresionrecibopagocargosprestamo(prestamo.cliente_nombre,localStorage.getItem('nombre_compania'),"Pago de cargos",new Date().toLocaleDateString(),totals.total,prestamo.loan_id,cargos.map(cargo => ({concepto: cargo.concepto, total: parseFloat(cargo.monto)})));

      // Reset form
      reiniciar();
      setCart([]);
      setShowPaymentMethodDialog(false);
      
    } catch (error) {
      console.error('Error processing payment:', error);
      setAlertTitle("Error");
      setAlertMessage("Error de conexión al procesar el pago");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return (
    <Grid container spacing={2} >
      {(prestamo && prestamoDetalle) ? (
        <Grid item size={8}>
            <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, bgcolor: "white" }}>
            
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Autocomplete
                      options={prestamos}
                      onChange={handlePrestamoChange}
                      getOptionLabel={(option) => 
                        {
                          var value = "";
                          JSON.parse(option.producto_financiero_formulario)["campos"].filter(formulario => formulario.busqueda).map(formulario => {
                            if(JSON.parse(option.solicitud_campos)[formulario.id]!=null) {
                              value += " - "+JSON.parse(option.solicitud_campos)[formulario.id];
                            }
                          })
                          return (option.loan_id+" - "+option.cliente_nombre+" - "+option.cliente_identificacion+value)}}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Box display={"flex"} flexDirection={"row"} justifyContent={"left"} mt={2} ml={2}>
                          <Typography variant="body2" color="text.secondary">
                            {option.loan_id} 
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ml:5, fontWeight:"bold"}}>
                            Cliente:
                          </Typography>
      
                          <Typography variant="body2" color="text.secondary" sx={{ml:1}}>
                            {option.cliente_identificacion}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ml:1}}>
                              - {option.cliente_nombre}
                          </Typography>
                          
      
                          {JSON.parse(option.producto_financiero_formulario)["campos"].filter(formulario => formulario.busqueda).map(formulario => {
                            if(JSON.parse(option.solicitud_campos)[formulario.id]!=null) {
                            return (
                            <>
                            <Typography variant="body2" color="text.secondary" sx={{ml:5, fontWeight:"bold"}}>
                            {formulario.name}:
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ml:1}}>
                              {JSON.parse(option.solicitud_campos)[formulario.id]}
                            </Typography>
      
                            </>
                            );
                            }
                            return null;
                          })}
                          </Box>
                        </li>
                      )}
                      renderInput={(params) => <TextField {...params} placeholder="Buscar prestamo"  InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" />
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }} fullWidth/>}
                      size="small"
                      value={prestamo}
                      inputValue={inputValuePrestamo}
                      onInputChange={(event, newInputValue) => {
                        setInputValuePrestamo(newInputValue);
                      }}
                      fullWidth

                    />                    
                  </Stack>
                  <Accordion sx={{mt:2, border:"none"}}>
                    <AccordionSummary
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "primary.main", // keep same on hover
                        },
                        "&.Mui-expanded": {
                          backgroundColor: "primary.main", // keep same on expand
                          minHeight: "48px", // optional: avoid MUI default minHeight jump
                        },
                        "& .MuiAccordionSummary-content.Mui-expanded": {
                          margin: 0, // optional: remove extra margin on expand
                        },
                      }}
                      expandIcon={<ExpandMore sx={{ color: "white" }} />}                     
                      aria-controls="panel1-content"
                      id="panel1-header">
                      <Typography variant="h6" sx={{fontWeight:"bold"}}>Datos de prestamo</Typography>
                      <Chip label={`Atraso: ${atraso?formatNumberWithCommas(atraso):"N/A"}`} color="error" sx={{mt:0.5,ml:4}}/>
                    </AccordionSummary>
                    {prestamoDetalle && (
                    <AccordionDetails>
                      <Box>
                      <Typography variant="h6" color="text.secondary" sx={{mt:2,ml:4}} textAlign={"left"}>Información General</Typography>
                          <Grid container spacing={1} mt={1}>
                            <Grid item size={4}>
                              <Typography variant="body1" sx={{fontWeight:"bold"}} color="text.secondary"> Nombre de cliente </Typography>
                              <Typography variant="body1"> {prestamo.cliente_nombre?prestamo.cliente_nombre:"N/A"} </Typography>
                            </Grid>
                            <Grid item size={4}> 
                              <Typography variant="body1" sx={{fontWeight:"bold"}} color="text.secondary"> Producto financiero </Typography>
                              <Typography variant="body1"> {prestamo.producto_financiero?prestamo.producto_financiero:"N/A"} </Typography>
                            </Grid>
                            <Grid item size={4}>
                              <Typography variant="body1" sx={{fontWeight:"bold"}} color="text.secondary"> Frecuencia </Typography>
                              <Typography variant="body1"> {prestamoDetalle.frecuencia?prestamoDetalle.frecuencia:"N/A"} </Typography>
                            </Grid>
                            <Grid item size={4} mt={1}>
                              <Typography variant="body1" sx={{fontWeight:"bold"}} color="text.secondary"> Tipo de interés </Typography>
                              <Typography variant="body1"> {prestamoDetalle.metodo?prestamoDetalle.metodo:"N/A"} </Typography>
                            </Grid>
                            <Grid item size={4} mt={1}>
                              <Typography variant="body1" sx={{fontWeight:"bold"}} color="text.secondary"> Producto </Typography>
                              <Typography variant="body1"> {prestamoDetalle.producto?prestamoDetalle.producto:"N/A"} </Typography>
                            </Grid>
                          </Grid>
                        <Typography variant="h6" color="text.secondary" sx={{mt:2,ml:4}} textAlign={"left"}>Resumen de pagos</Typography>
                        <Box display={"flex"} flexDirection={"row"} justifyContent={"center"} mt={2} ml={4} flexWrap="wrap">
                          <Button variant="outlined"  sx={{marginBottom:1,minWidth:200,fontWeight:"bold", marginRight:2,  borderColor:"primary.main", color:"primary.main"}}>Mora Pagada: {formatNumberWithCommas(prestamoDetalle.moraPagado)} </Button>
                          <Button variant="outlined"  sx={{marginBottom:1,fontWeight:"bold", marginRight:2,  borderColor:"primary.main", color:"primary.main"}}>Interes Pagado: {formatNumberWithCommas(prestamoDetalle.interesPagado)} </Button>
                          <Button variant="outlined"  sx={{marginBottom:1,fontWeight:"bold", marginRight:2,  borderColor:"primary.main", color:"primary.main"}}>Capital Pagado: {formatNumberWithCommas(prestamoDetalle.capitalPagado)} </Button>
                          <Button variant="outlined"  sx={{marginBottom:1,fontWeight:"bold", marginRight:2,  borderColor:"primary.main", color:"primary.main"}}>Total Pagado: {formatNumberWithCommas(prestamoDetalle.totalPagado)} </Button>

                          {prestamoDetalle.metodo != 'plazo_indefinido' && (
                            <>
                            <Button  variant="outlined" sx={{fontWeight: "bold",marginRight: 2,marginBottom: 1,borderColor: "error.main",color: "error.main",whiteSpace: "nowrap"}}>Mora Pendiente: {formatNumberWithCommas(parseFloat(prestamoDetalle.moraPendiente).toFixed(2))}</Button>
                            <Button  variant="outlined" sx={{fontWeight: "bold",marginRight: 2,marginBottom: 1,borderColor: "error.main",color: "error.main",whiteSpace: "nowrap"}}>Interes Pendiente: {formatNumberWithCommas(parseFloat(prestamoDetalle.interesPendiente).toFixed(2))}</Button>
                            </>
                          )}
                          <Button  variant="outlined" sx={{fontWeight: "bold",marginRight: 2,marginBottom: 1,borderColor: "error.main",color: "error.main",whiteSpace: "nowrap"}}>Capital Pendiente: {formatNumberWithCommas(prestamoDetalle.capitalPendiente?prestamoDetalle.capitalPendiente:prestamoDetalle.monto_solicitado)}</Button>  
                          <Button  variant="outlined" sx={{fontWeight: "bold",marginRight: 2,marginBottom: 1,borderColor: "error.main",color: "error.main",whiteSpace: "nowrap"}}>Total Pendiente: {prestamoDetalle.metodo == 'plazo_indefinido' ?
                           formatNumberWithCommas(prestamoDetalle.capitalPendiente?toNumber(prestamoDetalle.capitalPendiente)+amortizaciones.reduce((total, cuota) => total + toNumber(cuota.valor), 0):prestamoDetalle.monto_solicitado):
                           formatNumberWithCommas((parseFloat(prestamoDetalle.capitalPendiente)+parseFloat(prestamoDetalle.interesPendiente)+parseFloat(prestamoDetalle.moraPendiente)).toFixed(2))}</Button>
                          </Box>
                        <Divider sx={{mt:2,mb:2}} />
                        <Grid container spacing={1} >
                          <Grid item size={6}>
                            <Typography variant="h6" color="text.secondary" sx={{mt:2,ml:4}} textAlign={"left"}>Ultimo Pago</Typography>
                              <Box display={"flex"} flexDirection={"row"} justifyContent={"left"} mt={2} ml={4}>
                                <Button variant="outlined"  sx={{fontWeight:"bold", marginRight:5,  borderColor:"primary.main", color:"primary.main"}}>Fecha: {prestamoDetalle.fecha_ultimo_pago?prestamoDetalle.fecha_ultimo_pago:"N/A"} </Button>
                                <Button variant="outlined"  sx={{fontWeight:"bold", marginRight:5,  borderColor:"primary.main", color:"primary.main"}}>Valor: {prestamoDetalle.valor_ultimo_pago?prestamoDetalle.valor_ultimo_pago:"N/A"} </Button>
                              </Box>
                            </Grid>
                            <Grid item size={6}>
                              <Typography variant="h6" color="text.secondary" sx={{mt:2,ml:2}} textAlign={"left"}>Pagos Adicionales</Typography>
                              <Box display={"flex"} flexDirection={"row"} justifyContent={"left"} mt={2} ml={2}>
                                <Button variant="outlined"  sx={{fontWeight:"bold", marginRight:5,  borderColor:"primary.main", color:"primary.main"}}>Recuperaciones: {recuperaciones.length > 0 ? recuperaciones[0].monto_recuperacion : "N/A"} </Button>
                              </Box>
                            </Grid>
                        </Grid>
                        <Divider sx={{mt:2,mb:2}} />
                      </Box>

                      
                    </AccordionDetails>
                    )}
                  </Accordion>


                  {pagoTipo === "cuota" ? (
                  <Grid container spacing={2} mt={1}>
                    <Grid item size={3}>
                      <Box display={"flex"} flexDirection={"row"} justifyContent={"left"} mt={2} ml={2}>
                        <Can modulo="pagos" accion="editar">
                          <Button onClick={()=>{setShowEditPagosDialog(true)}} startIcon={<TableChart/>} variant="outlined"  sx={{fontWeight:"bold", marginRight:5,  backgroundColor:"primarybutton"}} color="primarybutton">Editar Cuotas</Button>
                        </Can>
                      </Box>
                    </Grid>
                    {prestamoDetalle && prestamoDetalle.metodo != 'plazo_indefinido' && (
                    <Grid item size={3}>
                      <Box mt={2} display="flex"  gap={2} flexWrap="wrap">
                        <Can modulo="pagos" accion="crear">
                          <Button
                            onClick={() => setShowAbonoCapitalDialog(true)}
                            startIcon={<SavingsOutlinedIcon />}
                            variant="outlined"
                            disabled={toNumber(atraso) > 0}
                            sx={{ fontWeight: "bold" }}
                          >
                            Abono a Capital
                          </Button>
                        </Can>
                        {toNumber(atraso) > 0 && (
                          <Typography variant="caption" color="text.secondary">
                            (Abono no disponible: el préstamo tiene atraso)
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  )}

                    <Grid item size={12}>
                      {prestamoDetalle.metodo == 'plazo_indefinido' && esInteresDiario ? (
                        <Box>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <StyledCellHeader sx={{textAlign:"center"}}>
                                  <Checkbox
                                    checked={areAllCuotasSelected()}
                                    indeterminate={areSomeCuotasSelected() && !areAllCuotasSelected()}
                                    onChange={(e) => handleSelectAllCuotas(e.target.checked)}
                                  />
                                </StyledCellHeader>
                                <StyledCellHeader sx={{textAlign:"center"}}>No. Dias</StyledCellHeader>
                                {/*JSON.parse(prestamoDetalle.interes_producto)['interesDiario'] ? <StyledCellHeader sx={{textAlign:"center"}}>Cuota Final</StyledCellHeader> : null*/}
                                <StyledCellHeader sx={{textAlign:"center"}}>Valor</StyledCellHeader>
                                <StyledCellHeader sx={{textAlign:"center"}}>Mora</StyledCellHeader>
                                <StyledCellHeader sx={{textAlign:"center"}}>A Pagar</StyledCellHeader>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {amortizaciones.map((amortizacion,index) => {
                                const isSelected = isCuotaSelected(amortizacion.nocuota);
                             
                                return (
                                <TableRow key={amortizacion.id} sx={{backgroundColor: isSelected ? "#f0f0f0" : "white"}}>
                                  <StyledCellHeader sx={{textAlign:"center"}}>
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={(e) => handleSelectCuota(amortizacion, e.target.checked)}
                                    />
                                  </StyledCellHeader>
                                  <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.dias_acumulados}</StyledCellHeader>
                                  {/*JSON.parse(prestamoDetalle.interes_producto)['interesDiario'] ? <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.cuotaoriginal}</StyledCellHeader> : null*/}
                                  <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.valor}</StyledCellHeader>                  
                                  <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.mora}</StyledCellHeader>
                                  <StyledCellHeader sx={{textAlign:"center"}}>{(toNumber(amortizacion.valor)+toNumber(amortizacion.mora)).toFixed(2)}</StyledCellHeader>
                                </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
  
                          </Box>
                          

                      ) : (
                        <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <StyledCellHeader sx={{textAlign:"center"}}>
                                <Checkbox
                                  checked={areAllCuotasSelected()}
                                  indeterminate={areSomeCuotasSelected() && !areAllCuotasSelected()}
                                  onChange={(e) => handleSelectAllCuotas(e.target.checked)}
                                />
                              </StyledCellHeader>
                              <StyledCellHeader>Fecha</StyledCellHeader>
                              <StyledCellHeader sx={{textAlign:"center"}}>No. Cuota</StyledCellHeader>
                              {/*JSON.parse(prestamoDetalle.interes_producto)['interesDiario'] ? <StyledCellHeader sx={{textAlign:"center"}}>Cuota Final</StyledCellHeader> : null*/}
                              <StyledCellHeader sx={{textAlign:"center"}}>Valor Cuota</StyledCellHeader>
                              <StyledCellHeader sx={{textAlign:"center"}}>Mora</StyledCellHeader>
                              <StyledCellHeader sx={{textAlign:"center"}}>A Pagar</StyledCellHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {amortizaciones.map((amortizacion,index) => {
                              const isSelected = isCuotaSelected(amortizacion.nocuota);
                              return (
                              <TableRow key={amortizacion.id} sx={{backgroundColor: isSelected ? "#f0f0f0" : "white"}}>
                                <StyledCellHeader sx={{textAlign:"center"}}>
                                  <Checkbox
                                    checked={isSelected}
                                    onChange={(e) => handleSelectCuota(amortizacion, e.target.checked)}
                                  />
                                </StyledCellHeader>
                                <StyledCellHeader>{amortizacion.Fecha}</StyledCellHeader>
                                <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.nocuota}</StyledCellHeader>
                                {/*JSON.parse(prestamoDetalle.interes_producto)['interesDiario'] ? <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.cuotaoriginal}</StyledCellHeader> : null*/}
                                <StyledCellHeader sx={{textAlign:"center"}}>{amortizacion.valor}</StyledCellHeader>                  

                                <StyledCellHeader sx={{textAlign:"center"}}>{toNumber(amortizacion.mora).toFixed(2)}</StyledCellHeader>
                                <StyledCellHeader sx={{textAlign:"center"}}>{(toNumber(amortizacion.valor)+toNumber(amortizacion.mora)).toFixed(2)}</StyledCellHeader>
                              </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      )}
                    </Grid>
                  </Grid>
                  ):(
                    <Grid container spacing={2} mt={1}>
                      {catalog
                        .filter((p) => !cargosAsignados.some((ca) => ca.id_categoria_cargo === p.id))
                        .map((p) => (
                        <Grid item key={p.id} size={3}>
                          <ProductCard item={p} onAdd={addToCart} selected={cart.some(item => item.id === p.id)} qty={cart.find(item => item.id === p.id)?.qty || 0} pagado={gestionCargosPagados.some(item => item.id_cargo === p.id)}/>
                        </Grid>
                      ))}

                    </Grid>
                  )
                  
                  }
                </Paper>

        </Grid>
        ):
        <Grid item size={prestamoDetalle?8:12} >
          <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, bgcolor: "white" }}>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
              <Autocomplete
                options={prestamos}
                onChange={handlePrestamoChange}
                getOptionLabel={(option) => 
                  {
                    var value = "";
                    JSON.parse(option.producto_financiero_formulario)["campos"].filter(formulario => formulario.busqueda).map(formulario => {
                      if(JSON.parse(option.solicitud_campos)[formulario.id]!=null) {
                        value += " - "+JSON.parse(option.solicitud_campos)[formulario.id];
                      }
                    })
                    return (option.loan_id+" - "+option.cliente_nombre+" - "+option.cliente_identificacion+value)}}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Box display={"flex"} flexDirection={"row"} justifyContent={"left"} mt={2} ml={2}>
                    <Typography variant="body2" color="text.secondary">
                      {option.loan_id} 
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ml:5, fontWeight:"bold"}}>
                      Cliente:
                    </Typography>

                    <Typography variant="body2" color="text.secondary" sx={{ml:1}}>
                      {option.cliente_identificacion}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ml:1}}>
                        - {option.cliente_nombre}
                    </Typography>
                    

                    {JSON.parse(option.producto_financiero_formulario)["campos"].filter(formulario => formulario.busqueda).map(formulario => {
                      if(JSON.parse(option.solicitud_campos)[formulario.id]!=null) {
                      return (
                      <>
                      <Typography variant="body2" color="text.secondary" sx={{ml:5, fontWeight:"bold"}}>
                      {formulario.name}:
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ml:1}}>
                        {JSON.parse(option.solicitud_campos)[formulario.id]}
                      </Typography>

                      </>
                      );
                      }
                      return null;
                    })}
                    </Box>
                  </li>
                )}
                renderInput={(params) => <TextField {...params} placeholder="Buscar prestamo"  InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }} fullWidth/>}
                size="small"
                fullWidth

              />                    
            </Stack>

            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
              minHeight={300}
              sx={{
                border: '1px dashed #bdbdbd',
                borderRadius: 2,
                bgcolor: '#fafafa',
                p: 4,
                mt: 4
              }}>
              <Typography variant="h5" color="text.secondary" gutterBottom>
                Selecciona un préstamo para ver los detalles
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Por favor, selecciona un préstamo en la lista para continuar.
              </Typography>
            </Box>
          </Paper>
        </Grid>
        }
        <Grid item size={4}>
          {prestamoDetalle && (
            <>
             {/* <Box display="flex" justifyContent="center" mb={2}>
              <ToggleButtonGroup
                  color="primary"
                  value={pagoTipo}
                  exclusive
                  onChange={(event, value) => setPagoTipo(value)}
                  aria-label="Pago"
                >
                  <ToggleButton value="cuota" sx={{fontWeight:"bold"}}>Pago de Cuota</ToggleButton>
                  <ToggleButton value="cargo" sx={{fontWeight:"bold"}}>Pago de Cargos</ToggleButton>
                </ToggleButtonGroup>
              </Box>  */}
              {pagoTipo === "cuota" ? (
                <ReceiptPagoPanel
                  prestamoDetalle={prestamoDetalle}
                  ultPago={ultPago}
                  cuotas={amortizaciones}
                  setSelectedCuotas={setSelectedCuotas}
                  selectedCuotas={selectedCuotas}
                  checkedCuotas={checkedCuotas}
                  shiftOpen={props.shiftOpen}
                  reiniciar={reiniciar}
                  recuperacionesValor={recuperaciones.length > 0 ? recuperaciones[0].monto_recuperacion : 0}
                  cargosAsignados={cargosAsignados}
                  onCargosCobrados={() => reloadCargosAsignados(prestamoDetalle?.prestamo_original_id)}
                />
              ) : (
                <InvoicePanel
                  items={cart}
                  onIncrease={increase}
                  onDecrease={decrease}
                  onRemove={removeItem}
                  totals={totals}
                  priceList={priceList}
                  setPriceList={setPriceList}
                  invoiceType={invoiceType}
                  setInvoiceType={setInvoiceType}
                  client={client}
                  onNewClient={() => setShowClientDialog(true)}
                  shiftOpen={props.shiftOpen}
                  onPaymentMethod={handlePaymentMethod}
                  prestamo={prestamo}
                  prestamoDetalle={prestamoDetalle}
                  selectedCuotas={selectedCuotas}
                  pagoTipo={pagoTipo}
                  setPagoTipo={setPagoTipo}
                  gestionCargosPagados={gestionCargosPagados}
                />
              )
              }
            </>
         )}
        </Grid>

        <MetodoDePagoDialog
          allowMultiple={true}
          open={showPaymentMethodDialog}
          onClose={() => setShowPaymentMethodDialog(false)}
          onConfirm={processPaymentCargos}
          amount={totals.total}
          title={ "Pago de Cargos"}
          description={ "Seleccione el método de pago para los cargos seleccionados"}
          showAmount={true}
          defaultMethod="efectivo"
        />

        <AlertMessageDialog
          open={alertOpen}
          setOpen={setAlertOpen}
          handleClose={handleAlertClose}
          title={alertTitle}
          message={alertMessage}
          severity={alertSeverity}
        />

        {prestamo!=null&& prestamoDetalle && (
        <EditAmortizationDialog
            open={showEditPagosDialog}
            onClose={() => setShowEditPagosDialog(false)}
            amortizacion={prestamo.metodo == 'plazo_indefinido' && esInteresDiario ? amortizaciones:amortizacionesEdit }
            prestamo={prestamo}
            moneda={"RD"}
            onSave={handleSaveAmortization}
          />
        )}

        {prestamo != null && prestamoDetalle && prestamoDetalle.metodo !== 'plazo_indefinido' && (
          <AbonoCapitalDialog
            open={showAbonoCapitalDialog}
            onClose={() => setShowAbonoCapitalDialog(false)}
            prestamo={prestamo}
            prestamoDetalle={prestamoDetalle}
            amortizacion={amortizacionesEdit}
            idcompany={localStorage.getItem('idcompany')}
            usuarioId={localStorage.getItem('id')}
            idSucursal={localStorage.getItem('id_sucursal')}
            idCliente={prestamo.id_cliente}
            moneda={"RD"}
            atraso={atraso}
            onSuccess={(res) => {
              setAlertTitle("Éxito");
              setAlertMessage(res?.message || "Abono a capital aplicado");
              setAlertSeverity("success");
              setAlertOpen(true);
              handlePrestamoChange(null, prestamo);
            }}
          />
        )}
         

    </Grid>

  );
}
